import { render } from "./UclTable.vue?vue&type=template&id=84f14d48&scoped=true"
import script from "./UclTable.vue?vue&type=script&lang=js"
export * from "./UclTable.vue?vue&type=script&lang=js"

import "./UclTable.vue?vue&type=style&index=0&id=84f14d48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f14d48"]])

export default __exports__